import { render, staticRenderFns } from "./shinetop.vue?vue&type=template&id=acf890d8&scoped=true"
import script from "./shinetop.vue?vue&type=script&lang=js"
export * from "./shinetop.vue?vue&type=script&lang=js"
import style0 from "./shinetop.vue?vue&type=style&index=0&id=acf890d8&prod&scoped=true&lang=css"
import style1 from "./shinetop.vue?vue&type=style&index=1&id=acf890d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf890d8",
  null
  
)

export default component.exports